var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 21.5625H24.4062C25.0273 21.5606 25.6223 21.3131 26.0615 20.874C26.5006 20.4348 26.7481 19.8398 26.75 19.2188V9.84375C26.7481 9.22272 26.5006 8.62765 26.0615 8.18852C25.6223 7.74938 25.0273 7.50185 24.4062 7.5H6.59375C5.97272 7.50185 5.37765 7.74938 4.93852 8.18852C4.49938 8.62765 4.25185 9.22272 4.25 9.84375V19.2188C4.25185 19.8398 4.49938 20.4348 4.93852 20.874C5.37765 21.3131 5.97272 21.5606 6.59375 21.5625H8",
    stroke: "#E8EAED",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.575 14.0625H9.425C8.63799 14.0625 8 14.7005 8 15.4875V24.825C8 25.612 8.63799 26.25 9.425 26.25H21.575C22.362 26.25 23 25.612 23 24.825V15.4875C23 14.7005 22.362 14.0625 21.575 14.0625Z",
    stroke: "#E8EAED",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7.5V6.09375C22.9981 5.47272 22.7506 4.87765 22.3115 4.43852C21.8723 3.99938 21.2773 3.75185 20.6562 3.75H10.3438C9.72272 3.75185 9.12765 3.99938 8.68852 4.43852C8.24938 4.87765 8.00185 5.47272 8 6.09375V7.5",
    stroke: "#E8EAED",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4688 12.1875C24.2454 12.1875 24.875 11.5579 24.875 10.7812C24.875 10.0046 24.2454 9.375 23.4688 9.375C22.6921 9.375 22.0625 10.0046 22.0625 10.7812C22.0625 11.5579 22.6921 12.1875 23.4688 12.1875Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinticon);
export default __webpack_public_path__ + "static/media/printicon.26790837290c3580ecbf9fe3fd5787fe.svg";
export { ForwardRef as ReactComponent };